<template>
  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div class="box-header">
      <div class="box-title">
        {{ $tc(moduleName === $constants.CMDB ? 'my_ci' : 'my_assets') }}
        <div class="total-count">
          {{ total }}
        </div>
      </div>
      <div class="box-action">
        <FlotoLink
          :to="
            moduleName === $constants.CMDB
              ? $currentModule.getRoute('my-ci', {
                  params: { assetType: $constants.CMDB },
                })
              : $currentModule.getRoute('my-assets', {
                  params: { assetType: $constants.ASSET },
                })
          "
        >
          <MIcon name="view-more" size="2x" />
        </FlotoLink>
      </div>
    </div>
    <MDivider class="mt-1 mb-2" />
    <div v-if="!myAssets.length" class="flex flex-1 items-center jutify-center">
      <FlotoNoData size="small" />
    </div>
    <MRow v-else :gutter="8">
      <MyAssetItem
        v-for="asset in myAssets"
        :key="asset.id"
        :card-width="cardWidth"
        :module-name="moduleName"
        :item="asset"
      />
    </MRow>
  </div>
</template>

<script>
import { getMyAssetApi } from '@modules/asset/asset-api'
import { transformAssetForList } from '@data/asset'
import MyAssetItem from './my-asset-item.vue'
export default {
  name: 'MyAssets',
  components: { MyAssetItem },
  props: {
    moduleName: {
      type: String,
      default() {
        return this.$constants.ASSET
      },
    },
  },
  data() {
    return {
      myAssets: [],
      total: 0,
      cardWidth: '33%',
    }
  },
  created() {
    this.getMyAssets()
  },
  methods: {
    getMyAssets() {
      getMyAssetApi(this.moduleName, { size: 3, offset: 0 }).then((data) => {
        const myAssets = (data.objectList || []).slice(0, 4).map(
          (i) => transformAssetForList({ ...i, relationId: 'fake_id' }) // add fake relation id for combined ids
        )
        this.myAssets = myAssets
        this.cardWidth = `${Math.round(100 / myAssets.length)}%`
        this.total = data.totalCount
      })
    },
  },
}
</script>

<style lang="less" scoped>
.box-header {
  @apply flex justify-between items-center min-w-0;

  & .box-title {
    @apply flex pb-1;

    font-size: 0.898rem;
    font-weight: 500;
    color: var(--primary-alt);
  }

  & .total-count {
    @apply flex px-2 items-center rounded;

    margin: 0 0.418rem;
    font-size: 0.7rem;
    color: var(--primary-alt);
    background-color: rgba(50, 121, 190, 0.2);
  }

  & .box-action {
    @apply cursor-pointer;

    color: var(--primary);
  }
}
</style>
